<template>
  <a-form :form="form" @submit.prevent="handleConfigInfoSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="30">

      <!-- 活体检测 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.recognizer.vivoDetectionTitle')}}</h3>
        <!-- 是否启用活体检测功能 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.vivoDetectionTitle')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['enableLiveDetection',{ initialValue: deviceConfig.enableLiveDetection || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 人脸检测 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.recognizer.faceDetectionTitle')}}</h3>
        <!-- 人脸识别角度 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.faceRecognitionAngle')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['faceDetectAngle',{ initialValue: deviceConfig.faceDetectAngle || '0' }]"
            >
              <a-select-option value="0">0°</a-select-option>
              <a-select-option value="30">30°</a-select-option>
              <a-select-option value="45">45°</a-select-option>
              <a-select-option value="60">60°</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 人脸识别失败提醒时间 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.reminderTime')">
            <a-input
              :placeholder="$t('devicesManaConfig.recognizer.reminderTimeTxt')"
              :suffix="$t('devicesManaConfig.recognizer.reminderTimeUnit')"
              v-decorator="[
                'faceDetectReminderTime',
                { 
                  initialValue: deviceConfig.faceDetectReminderTime || '3',
                  rules: [
                    { required: true, message: $t('devicesManaConfig.recognizer.reminderTimeBlank')},
                    { pattern: /^[1-9]\d*$/, message: $t('devicesManaConfig.recognizer.reminderTimeWarning') },
                    { validator: checkFaceDetectReminderTime, trigger: ['blur', 'change']}
                  ]
                }
                
              ]"
            ></a-input>
          </a-form-item>
        </a-col>   
        <!-- 人脸识别阈值 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.faceRecognitionThreshold')">
            <a-col :span="14">
              <a-slider 
                :min="1" 
                :max="100"
                :marks="{1: '1', 100: '100'}"
                @change="value => inputFaceDetectThreshold = value"
                v-decorator="['faceDetectThreshold',{ 
                   initialValue: deviceConfig.faceDetectThreshold || 60,
                   rules: [{ required: true,message: '请选择人脸识别阈值!' }] 
                  }
                ]"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                :min="1" 
                :max="100"
                style="marginLeft: 22px;width:70px"
                @change="value => form.setFieldsValue({faceDetectThreshold: value})"
                v-model="inputFaceDetectThreshold"
              />
            </a-col>
          </a-form-item>
        </a-col>
        <!-- 芯片照和现场照脸识别阈值 -->
        <!-- <a-col :span="12">
          <a-form-item :label="$t('devicesManaConfig.recognizer.citizenFaceRecognitionThreshold')">
            <a-col :span="14">
              <a-slider 
                :min="1" 
                :max="100"
                :marks="{1: '1', 100: '100'}"
                @change="value => inputCitizenFaceDetectThreshold = value"
                v-decorator="['citizenFaceDetectThreshold',{ 
                   initialValue: deviceConfig.citizenFaceDetectThreshold || 60,
                   rules: [{ required: true,message: '请选择人脸识别阈值!' }] 
                  }
                ]"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                :min="1" 
                :max="100"
                style="marginLeft: 22px;width:70px"
                @change="value => form.setFieldsValue({citizenFaceDetectThreshold: value})"
                v-model="inputCitizenFaceDetectThreshold"
              />
            </a-col>
          </a-form-item>
        </a-col> -->
        
        <!-- 人脸识别距离 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.faceRecognitionDistance')">
            <a-col :span="14">
              <a-slider 
                :min="1" 
                :max="100"
                :marks="{1: '1', 100: '100'}"
                @change="value => inputFaceDetectDistance = value"
                v-decorator="['faceDetectDistance',{ 
                    initialValue: deviceConfig.faceDetectDistance || 50,
                    rules: [{ 
                      required: true,
                      message: '请选择人脸识别距离!' 
                    }] 
                  }
                ]"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                :min="1" 
                :max="100"
                style="marginLeft: 22px;width:70px"
                @change="value => form.setFieldsValue({faceDetectDistance: value})"
                v-model="inputFaceDetectDistance"
              />
            </a-col>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 口罩检测 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.recognizer.maskDetectionTitle')}}</h3>
        <!-- 是否启用口罩检测功能 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.enableMaskDetection')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['enableMaskDetect',{ initialValue: deviceConfig.enableMaskDetect || '1' }]"
              @change='handleChangeEnableMaskDetect'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 未检测到口罩不打开门禁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.closedWhenNoMask')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenMaskDetect"
              v-decorator="['noMaskNotOpen',{ initialValue: deviceConfig.noMaskNotOpen || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 体温检测 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.recognizer.temperatureDetectionTitle')}}</h3>
        <!-- 是否启用体温检测功能 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.enableTemperatureDetection')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['enableTempDectet',{ initialValue: deviceConfig.enableTempDectet || '1' }]"
              @change='handleChangeEnableTempDectet'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 体温异常不打开门禁 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.closedWhenAbnormothermia')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenTempDectet"
              v-decorator="['tempExceptNotOpen',{ initialValue: deviceConfig.tempExceptNotOpen || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 体温异常值 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.temperatureAnomaly')">
            <a-input
              :placeholder="$t('devicesManaConfig.recognizer.temperatureAnomalyTxt')"
              suffix="℃"
              v-decorator="[
                'tempExceptValue',
                { 
                  initialValue: deviceConfig.tempExceptValue || '37.4',
                  rules: [
                    { required: true, message: $t('devicesManaConfig.recognizer.temperatureAnomalyBlank')},                    
                    { validator: checkTempExceptValue, trigger: ['blur', 'change']}
                  ]
                }
                
              ]"
            >
              <span slot="addonBefore">>=</span>
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 是否显示热成像 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.showThermalImagery')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isOpenTempDectet"
              v-decorator="['displayThermalImaging',{ initialValue: deviceConfig.displayThermalImaging || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 识别记录 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.recognizer.recogRecordTitle')}}</h3>
        <!-- 是否保存识别记录 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.saveRecogRecord')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['saveRecogData',{ initialValue: deviceConfig.saveRecogData || '1' }]"
              @change='handleChangeSaveRecogData'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否自动同步识别记录到服务器 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.autoSyncRecordedToServer')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isSaveRecogData"
              v-decorator="['autoSaveDataToServer',{ initialValue: deviceConfig.autoSaveDataToServer || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否保存识别现场照 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.saveSitePhotos')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['saveRecogPhoto',{ initialValue: deviceConfig.saveRecogPhoto || '1' }]"
              @change='handleChangeSaveRecogPhoto'
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否自动同步现场照到服务器 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.autoSyncSitePhotosToServer')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :disabled="!isSaveRecogPhoto"
              v-decorator="['autoSavePhotoToServer',{ initialValue: deviceConfig.autoSavePhotoToServer || '1' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 同步成功后是否自动删除已同步数据 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.recognizer.deleteDataAfterAutoSync')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['autoDeleteSyncData',{ initialValue: deviceConfig.autoDeleteSyncData || '2' }]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.recognizer.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.recognizer.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <a-col :span="24" style="margin-top: 16px; text-align: right">
        <a-button 
          type="primary" 
          html-type="submit" 
          :loading="submitting"
        >{{$t('devicesManaConfig.recognizer.submitBtn')}}</a-button>
        <a-button 
          :style="{ marginLeft: '8px' }" 
          @click="$emit('backList')"
        >{{$t('devicesManaConfig.recognizer.backBtn')}}</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {},
  props: {
    deviceConfig: {
      type: Object,
      required: true,
      default: null
    },
    deviceId: {
      type: String,
      required: true,
      default: undefined
    }
  },
  data() {
    return {
      lastDeviceId: null,

      form: this.$form.createForm(this),

      inputFaceDetectDistance: 50,
      inputFaceDetectThreshold: 60,
      // inputCitizenFaceDetectThreshold: 60,

      isOpenMaskDetect: true, // 是否启用口罩检测功能
      isOpenTempDectet: true, // 是否启用体温检测功能
      
      isSaveRecogData: true, // 是否启用体温检测功能
      isSaveRecogPhoto: true, // 是否保存识别现场照

      submitting: false
    }
  },
  created() {
    // console.log('--RecognizerSettingForm created--', this.deviceConfig);
    // this.lastDeviceId = this.deviceId 
    // this.initConfig()    
  },
  activated() {
    if (this.deviceId !== this.lastDeviceId) {
      this.lastDeviceId = this.deviceId 
      this.initConfig()    
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    // 处理进入本类配置的数据
    initConfig() {
      this.$nextTick(() => {
        this.inputFaceDetectDistance = this.deviceConfig.faceDetectDistance || this.inputFaceDetectDistance;
        this.inputFaceDetectThreshold = this.deviceConfig.faceDetectThreshold || this.inputFaceDetectThreshold;
        // this.inputCitizenFaceDetectThreshold = this.deviceConfig.citizenFaceDetectThreshold || this.inputCitizenFaceDetectThreshold;

        this.isOpenMaskDetect = this.deviceConfig.enableMaskDetect !== '2';
        this.isOpenTempDectet = this.deviceConfig.enableTempDectet !== '2';
        this.isSaveRecogData = this.deviceConfig.saveRecogData !== '2';
        this.isSaveRecogPhoto = this.deviceConfig.saveRecogPhoto !== '2';
      })
    },
    // 提交配置信息
    handleConfigInfoSubmit() {
      this.form.validateFields((err, values) => {
        // console.log('--handleConfigInfoSubmit--', err, values)
        if (!err) {
          let config = Object.assign({}, values);

          config.faceDetectDistance = String(config.faceDetectDistance);
          config.faceDetectThreshold = String(config.faceDetectThreshold);
          // config.citizenFaceDetectThreshold = String(config.citizenFaceDetectThreshold);
          
          this.$emit('submitConfig', config)
        }
      })
    },

    // 自定义人脸识别失败提醒时间数值范围校验
    checkFaceDetectReminderTime(rule, value, callback) {
      if (value && Number(value) > 10) {
        callback(this.$t('devicesManaConfig.recognizer.reminderTimeMax'));
        return;
      }
      callback();
    },
    // 自定义体温异常值数值范围校验
    checkTempExceptValue(rule, value, callback) {
      if (value && Number(value) > 100) {
        callback(this.$t('devicesManaConfig.recognizer.temperatureAnomalyMax'));
        return;
      }
      if (value && Number(value) < 1) {
        callback(this.$t('devicesManaConfig.recognizer.temperatureAnomalyMin'));
        return;
      }
      const regx = /^\d*\.{0,1}\d{0,1}$/
      if (!regx.test(value)) {
        callback(this.$t('devicesManaConfig.recognizer.temperatureAnomalyWarning'));
        return;
      }
      callback();
    },

    // 是否启用口罩检测功能改变
    handleChangeEnableMaskDetect(value) {
      let vm = this;
      if (value !== '2') {
        this.isOpenMaskDetect = true;
        this.$nextTick(() => {
          this.form.validateFields(['noMaskNotOpen'], { force: true });
        });
      } else {
        this.isOpenMaskDetect = false;
      }
    },
    // 是否启用体温检测功能改变
    handleChangeEnableTempDectet(value) {
      let vm = this;
      if (value !== '2') {
        this.isOpenTempDectet = true;
        this.$nextTick(() => {
          this.form.validateFields(['tempExceptNotOpen', 'tempExceptValue', 'displayThermalImaging'], { force: true });
        });
      } else {
        this.isOpenTempDectet = false;
      }
    },
    // 是否保存识别记录改变 
    handleChangeSaveRecogData(value) {
      let vm = this;
      if (value !== '2') {
        this.isSaveRecogData = true;
        this.$nextTick(() => {
          this.form.validateFields(['autoSaveDataToServer'], { force: true });
        });
      } else {
        this.isSaveRecogData = false;
      }
    },    
    // 是否保存识别现场照改变 
    handleChangeSaveRecogPhoto(value) {
      let vm = this;
      if (value !== '2') {
        this.isSaveRecogPhoto = true;
        this.$nextTick(() => {
          this.form.validateFields(['autoSavePhotoToServer'], { force: true });
        });
      } else {
        this.isSaveRecogPhoto = false;
      }
    }

  }    
}
</script>

<style scoped>
</style>